import bannerImg from "@/assets/infinite-banking-authorized-practitioner-banner.png";

export const AuthorizedPractitionerBanner = () => (
  <section
    data-testid="authorized-practitioner-banner"
    className="w-full bg-[#111111] py-6 md:py-8"
  >
    <div className="w-full px-4">
      <img
        src={bannerImg}
        alt="Infinite Banking Concepts Authorized Practitioner banner"
        loading="lazy"
        className="mx-auto block h-auto w-full object-contain"
      />
    </div>
  </section>
);
